<ng-container [formGroup]="form">
  <div [class.py-12]="viewportMode === 'mobile'" [class.py-8]="viewportMode !== 'mobile'">
    <blaze-checkbox
      class="with-theme select-all"
      [checked]="allSelected"
      [indeterminate]="someSelected()"
      (change)="toggleAll($event.checked)"
      >Select All</blaze-checkbox
    >
  </div>
  @for (control of filtersFormGroups; track control; let i = $index) {
    <div
      class="flex flex-col items-start max-w-full"
      [class.py-12]="viewportMode === 'mobile'"
      [class.py-8]="viewportMode !== 'mobile'"
    >
      <ng-container [formGroup]="control">
        <blaze-checkbox
          formControlName="selected"
          class="with-theme"
          [blazeTooltip]="control.value.name"
          [matTooltipShowDelay]="300"
          [matTooltipTouchGestures]="'off'"
        >
          <div
            class="w-fit px-8 py-4 rounded-full overflow-hidden text-ellipsis max-w-full"
            [style]="
              control.value.selected
                ? calendarsStyles[control.value.name]
                : {
                    background: 'transparent',
                    color: 'rgba(55,55,55,0.5)',
                  }
            "
          >
            {{ control.value.name }}
          </div>
        </blaze-checkbox>
      </ng-container>
    </div>
  }
</ng-container>
